import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { LeagueProvider } from "@leagueplatform/core";
import { config } from "config";
import { appRoutes } from "app-routes";

const LeagueProviderWrapper = () => (
  <LeagueProvider config={config}>
    <Outlet />
  </LeagueProvider>
);

const router = createBrowserRouter([
  {
    element: <LeagueProviderWrapper />,
    children: appRoutes,
  },
]);

export const App = () => <RouterProvider router={router} />;
